import { errorHandler } from "src/app/util/errorHandler";
import { Router } from "@angular/router";
import { environment } from "./../../../../environments/environment";
import { authData, saveAuth } from "src/app/util/auth";
import { Component, OnInit } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Component({
  selector: "app-bio-data-passport",
  templateUrl: "./bio-data-passport.component.html",
})
export class BioDataPassportComponent implements OnInit {
  constructor(private httpClient: HttpClient, private router: Router) {}

  url: any = null;
  studentPassport = null;
  _checks = authData("_checks");
  _isApplication = authData("_isApplication");

  loading = false;
  notification = {};
  status: boolean = false;
  payload = { ImageSize: 0, ImageType: "", PassportData: "", IsApplication: this._isApplication };

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + authData().Token,
    }),
  };

  ngOnInit(): void {
    if (this._checks.PassportPhotoLocked) {
      this.notification = {
        error: true,
        message: "Passport locked!",
      };
    }

    const baseUrl = `${environment.BASE_URL}/users/passport?isApplication=${this._isApplication}`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe({
      next: (res: any) => {
        if (res.Success) {
          this.studentPassport = res.Data.PassportData;
        }
      },
    });
  }

  generatePreview(event: any): void {
    const file = event.target.files[0];

    if (event.target.files && file) {
      if (file.size > 2097152) {
        this.payload = { ImageSize: 0, ImageType: "", PassportData: "", IsApplication: this._isApplication };
        this.notification = errorHandler({
          Message: "Image File size too large",
        });
      } else {
        const reader = new FileReader();
        reader.onload = (event: any) => {
          const name = file.name;
          const lastDot = name.lastIndexOf(".");

          this.payload = {
            ImageSize: file.size,
            ImageType: name.substring(lastDot + 1),
            PassportData: event.target.result.replace(
              /^data:image\/\w+;base64,/,
              ""
            ),
            IsApplication: this._isApplication
          };
        };

        reader.readAsDataURL(file);
      }
    }
  }

  updatePassport() {
    if (this._checks.PassportPhotoLocked || this.loading) return;

    this.loading = true;
    this.notification = {};

    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "Bearer " + authData().Token,
      }),
    };

    const baseUrl = `${environment.BASE_URL}/users/savePassport`;
    this.httpClient.post(baseUrl, this.payload, httpOptions).subscribe(
      (res: any) => {
        saveAuth({ ...authData(), StudentPassport: this.payload.PassportData });
        if (this._isApplication) {
          this.router.navigateByUrl("/application#Passport+updated");
        }
        else {
          this.router.navigateByUrl("/bio-data#Passport+updated");
        }
      },
      (err) => {
        this.loading = false;
        this.notification = errorHandler(err);
      }
    );
  }
}
